import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { makeLogout } from 'src/utils/auth';
import { captureException } from '@sentry/react';

export const CallbackPage = () => {
  const { isLoading, isAuthenticated, logout: logoutAuth0, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !error && isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isLoading, isAuthenticated, error, navigate]);

  const fullLogout = (path: 'auth' | 'verify') => {
    makeLogout({ noEvents: true });
    logoutAuth0({ logoutParams: { returnTo: `${window.location.protocol}//${window.location.host}/${path}` } });
  };

  if (error) {
    captureException(error);
    fullLogout('verify');
    return null;
  }

  return null;
};
